
import React from "react"
import { useLightbox } from 'simple-react-lightbox'

export default function LightboxBtn({start,total}) 
{
	const { openLightbox, closeLightbox } = useLightbox()
	const init = start || 1

	return (
		<div className="lightbox-btn" onClick={() => openLightbox(init)}>
			View all {total}
		</div>
	)
}